export function removeBackslashes(inputString) {
    // Check if inputString is a string, if not, return it as is
    if (typeof inputString !== 'string') {
        return inputString;
    }
    return inputString.replace(/\\/g, '');
}

